import { Bath, Coffee, Clock, Brush, BedDouble, Utensils, Car, Info, Wine, Baby, Snowflake, KeyRound } from "lucide-react";

export const QUICK_ICONS = {
  bath: { Icon: Bath, label: "Asciugamani / bagno" },
  coffee: { Icon: Coffee, label: "Colazione / caffè" },
  clock: { Icon: Clock, label: "Orario" },
  broom: { Icon: Brush, label: "Pulizie" },
  bed: { Icon: BedDouble, label: "Letto / cuscini" },
  utensils: { Icon: Utensils, label: "Ristorante" },
  car: { Icon: Car, label: "Auto / taxi" },
  info: { Icon: Info, label: "Informazioni" },
  wine: { Icon: Wine, label: "Vino / bar" },
  baby: { Icon: Baby, label: "Bambini" },
  snowflake: { Icon: Snowflake, label: "Aria condizionata" },
  key: { Icon: KeyRound, label: "Chiavi / accesso" },
};

export function quickIcon(name) {
  return (QUICK_ICONS[name] || QUICK_ICONS.info).Icon;
}

export function fillQuickText(tpl, { nome, camera }) {
  return (tpl || "").replaceAll("{nome}", nome).replaceAll("{camera}", camera);
}
